import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useSeo } from "../lib/ui";

export default function StubPage({ title, kicker, body }) {
  useSeo({ title: `${title} — KickStartKenyaFootball`, description: body });

  return (
    <div className="bg-black pb-32 pt-12 md:pt-16" data-testid="stub-page">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <p className="overline">{kicker}</p>
        {kicker === "Coming Soon" ? (
          <span className="mt-5 inline-block border border-white/20 px-2.5 py-1 text-[0.52rem] font-bold uppercase tracking-[0.18em] text-zinc-400" data-testid="stub-coming-soon">
            Coming soon
          </span>
        ) : null}
        <h1 className="display-1 mt-5 max-w-4xl" data-testid="stub-title">{title}</h1>
        <p className="serif mt-10 max-w-2xl text-xl italic leading-relaxed text-zinc-300 md:text-2xl">{body}</p>
        <div className="mt-14 grid gap-px border border-zinc-800 bg-zinc-800 sm:grid-cols-3">
          {[
            ["Recommended Steps", "The recommended steps, with indicative costs.", "/plans"],
            ["All Players", "Every Kenyan professional abroad, archived by era.", "/hall-of-fame"],
            ["Send a proposal", "Tell us how you would deliver a facility or a step.", "/apply"],
          ].map(([t, d, to]) => (
            <Link key={to} to={to} className="group bg-[#0b0b0b] p-8 transition-colors hover:bg-ink-hover">
              <h2 className="font-display text-lg font-semibold uppercase text-white">{t}</h2>
              <p className="body-copy mt-3">{d}</p>
              <span className="mt-6 inline-flex items-center gap-2 text-[0.68rem] font-bold uppercase tracking-[0.18em] text-ochre">
                Go <ArrowRight size={13} />
              </span>
            </Link>
          ))}
        </div>
        <p className="mt-14 max-w-2xl text-sm leading-relaxed text-zinc-500">
          This section is still being written and will be published from the admin panel. In the meantime, treat any
          figures elsewhere on the site as planning estimates, and note that we are not currently running player trials —
          coaching, pathway and academy information is published as general guidance only.
        </p>
      </div>
    </div>
  );
}
